'use es6';

import { Map as ImmutableMap, List } from 'immutable';
import { SEARCH } from 'reporting-data/constants/configTypes';
import * as http from 'reporting-data/request/http';
import { getTableData, getChartData, addStaticAmountReferences, AGGREGATION_PROPS, sortBreakdowns } from './helpers';
import { isSearch, translateFilters, getQuery } from '../lib/salesAnalytics/helpers';
import { Dataset } from 'reporting-data/v2/dataset/datasetRecords';
import resolveProperties from '../lib/salesAnalytics/resolveProperties';
import generateReferences from '../lib/salesAnalytics/generateReferences';
import { getDrilldownFields } from '../lib/salesAnalytics/drilldownColumns';
const resolveData = report => {
  return report.getIn(['config', 'configType']) === SEARCH ? http.post('sales-reporting/snapshots/objects', {
    query: getQuery(report),
    data: {
      config: report.get('config').delete('offset'),
      offset: report.getIn(['config', 'offset'])
    }
  }).then(response => ({
    report,
    response
  })) : http.post('sales-reporting/snapshots/counts', {
    query: getQuery(report),
    data: report.get('config').delete('limit').delete('offset')
  }).then(response => ({
    report,
    response
  }));
};
const transformAggregation = ({
  report,
  response
}) => {
  const ending_currency = response.get('metrics_primary');
  const currencyChangePercent = response.get('metrics_secondary');
  if (report.get('chartType') === 'TABLE') {
    return {
      report,
      response,
      datasets: ImmutableMap({
        primary: Dataset({
          data: getTableData(report, response)
        })
      })
    };
  }
  return {
    report,
    response,
    datasets: ImmutableMap({
      primary: Dataset({
        data: getChartData(report, response)
      }),
      summary: Dataset({
        data: [{
          metrics_primary: ending_currency,
          metrics_secondary: currencyChangePercent
        }]
      })
    })
  };
};
const transformSearch = ({
  report,
  response
}) => {
  const objects = response.get('objects', List()).map(object => object.get('properties').map(property => property.get('value')).set('objectId', object.get('objectId')).set('snapshot_period_closedate', object.get('snapshot_period_closedate')).set('snapshot_period_amount_in_home_currency', object.get('snapshot_period_amount_in_home_currency')).set('snapshot_period_dealstage', object.get('snapshot_period_dealstage')));
  const datasets = ImmutableMap({
    primary: Dataset({
      data: objects,
      paginationSize: response.get('total')
    })
  });
  return {
    report,
    response,
    datasets
  };
};
export default (report => {
  const {
    props,
    transformFn,
    adjustReferences
  } = isSearch(report) ? {
    props: getDrilldownFields(report),
    transformFn: transformSearch,
    adjustReferences: x => x
  } : {
    props: AGGREGATION_PROPS,
    transformFn: transformAggregation,
    adjustReferences: addStaticAmountReferences
  };
  return translateFilters(report).then(resolveData).then(transformFn).then(resolveProperties(props)).then(generateReferences).then(adjustReferences).then(sortBreakdowns).then(({
    datasets
  }) => datasets.map(dataset => ImmutableMap({
    data: dataset
  })));
});